import {
  PROPOSE_TASK_LIST, PROPOSE_TASK_LIST_FAILURE, PROPOSE_TASK_LIST_SUCCESS
} from './mutation-types'

export default {
  state: {
    proposeTaskList: [],
    proposeTaskListNextPage: null,
    proposeTaskListCurrentPage: null
  },
  getters: {
    proposeTasks: state => {
      return state.proposeTaskList
    },
    proposeTaskListNextPage: state => {
      return state.proposeTaskListNextPage
    },
    proposeTaskListCurrentPage: state => {
      return state.proposeTaskListCurrentPage
    }
  },
  actions: {
    [PROPOSE_TASK_LIST] ({dispatch, state, commit}, params) {
      let url = '/master/propose_tasks/'
      if (params.url) {
        url = params.url
      }
      let data = {}
      let callback = null
      data = params.data
      params.callback && (callback = params.callback)
      dispatch('apiGet', {url: url, data: data, callback: callback})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(PROPOSE_TASK_LIST_FAILURE, res.data)
          } else {
            res.data.callback = callback
            commit(PROPOSE_TASK_LIST_SUCCESS, res.data)
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [PROPOSE_TASK_LIST_FAILURE] (state, data) {
      console.log('PROPOSE_TASK_LIST_FAILURE')
    },
    [PROPOSE_TASK_LIST_SUCCESS] (state, data) {
      console.log('PROPOSE_TASK_LIST_SUCCESS')
      let reSearch = false
      if (data.meta && data.meta['re-search']) {
        reSearch = data.meta['re-search']
      }
      if (reSearch) {
        // 再検索
        state.proposeTaskList = data.data
      } else {
        if (data.meta && data.meta['current-page'] && data.meta['current-page'] > 1) {
          state.proposeTaskList = state.proposeTaskList.concat(data.data)
          state.proposeTaskListCurrentPage = data.meta['current-page']
          state.proposeTaskListNextPage = data.meta['next-page']
        } else {
          state.proposeTaskList = data.data
          state.proposeTaskListCurrentPage = 1
          state.proposeTaskListNextPage = data.meta['next-page']
        }
      }
      if (data.callback) {
        data.callback()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/propose-task-list.js